import styled from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

export const Wrapper = styled.main<{
	isBannerVisible: boolean;
}>`
	background: ${palette('gray0')};
	position: relative;

	min-height: calc(
		100vh - ${theme('app.mobileHeaderHeight')} -
			${ifProp('isBannerVisible', theme('app.mobileBannerHeight'), '0px')}
	);
	top: ${ifProp('isBannerVisible', theme('app.mobileBannerHeight'), '0px')};

	${minWidth('tablet')} {
		min-height: calc(
			100vh - ${theme('app.headerHeight')} - ${ifProp('isBannerVisible', theme('app.bannerHeight'), '0px')}
		);
		top: ${ifProp('isBannerVisible', theme('app.bannerHeight'), '0px')};
	}
`;
